import script from "./EzTableLoadingState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EzTableLoadingState.vue?vue&type=script&setup=true&lang=ts"

import "./EzTableLoadingState.vue?vue&type=style&index=0&id=bc59068e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc59068e"]])

export default __exports__